import type { Schemas } from '@/api/types'
import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { useApi } from '@/composables/useApi.js'

export type FeatureBlock = Schemas['FeatureBlock']
export type FeatureBlockAttributes = NonNullable<FeatureBlock['attributes']>

const featureBlockKeys = {
  all: ['feature-blocks'] as const,
  lists: () => [...featureBlockKeys.all, 'list'] as const,
  list: (departmentId: MaybeRef<string>) =>
    [...featureBlockKeys.lists(), departmentId] as const,
}

export const useDepartmentFeatureBlocksQuery = (
  departmentId: MaybeRef<string>,
  options?: {
    enabled?: MaybeRef<boolean>
  },
) => {
  const api = useApi()
  const route = useRoute()

  const query = useQuery({
    placeholderData: keepPreviousData,
    queryKey: featureBlockKeys.list(departmentId),
    queryFn: () =>
      api((client) =>
        client.GET('/{provet_id}/api/departments/{id}/feature_blocks', {
          params: {
            path: {
              provet_id: route.params.provetId as string,
              id: unref(departmentId),
            },
          },
        }),
      ),
    enabled: computed(
      () =>
        (options?.enabled !== undefined ? unref(options.enabled) : true) &&
        !!unref(departmentId),
    ),
  })

  return reactive(query)
}
